export * as recordResponsiblePersons from './record-responsible-persons'
